import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, formatTarih, waLink } from '../lib/api';
import { useAuth } from '../lib/auth';

type Hatirlatma = {
  id: number; title: string; dueAt: string; status: string;
  cari: { id: number; name: string; phone: string | null } | null;
  sahip: string | null; gecikti: boolean; bugun: boolean;
};

/** BUGÜN — vadesi gelen hatırlatmalar (CRM eki 13.2, /bugun komutunun eşi). */
export default function Bugun() {
  const [kapsam, setKapsam] = useState<'bugun' | 'acik' | 'hepsi'>('bugun');
  const { can } = useAuth();
  const [satirlar, setSatirlar] = useState<Hatirlatma[] | null>(null);
  const [hata, setHata] = useState<string | null>(null);

  const yukle = useCallback(() => {
    api<{ satirlar: Hatirlatma[] }>(`/api/crm/hatirlatmalar?kapsam=${kapsam}`)
      .then((r) => setSatirlar(r.satirlar)).catch((e) => setHata((e as Error).message));
  }, [kapsam]);
  useEffect(yukle, [yukle]);

  async function durum(id: number, status: string) {
    await api(`/api/crm/hatirlatma/${id}/durum`, { method: 'POST', body: JSON.stringify({ status }) })
      .catch((e) => setHata((e as Error).message));
    yukle();
  }

  const geciken = satirlar?.filter((h) => h.gecikti) ?? [];

  return (
    <>
      <div className="ccd-row-between" style={{ gap: 12 }}>
        <div style={{ minWidth: 0 }}>
          <h1 className="ccd-title">Bugün</h1>
          <div className="ccd-meta">Vadesi gelen hatırlatmalar · tamamlananlar listeden düşer</div>
        </div>
        <button type="button" className="ccd-btn ccd-btn-sm" onClick={yukle} title="Listeyi yeniden çek">Yenile</button>
      </div>

      {hata && (
        <div className="ccd-banner ccd-banner-danger">
          <span className="ccd-banner-icon">!</span><span>{hata}</span>
        </div>
      )}

      {geciken.length > 0 && (
        <div className="ccd-banner ccd-banner-danger">
          <span className="ccd-banner-icon" aria-hidden="true">!</span>
          <span><b>{geciken.length} hatırlatmanın vadesi geçti.</b></span>
        </div>
      )}

      <div className="ccd-tabs" role="tablist">
        {([['bugun', 'Bugün'], ['acik', 'Tüm açıklar'], ['hepsi', 'Geçmiş dahil']] as const).map(([id, ad]) => (
          <button key={id} role="tab" aria-selected={kapsam === id} className="ccd-tab"
                  onClick={() => setKapsam(id)}>{ad}</button>
        ))}
      </div>

      {!satirlar ? (
        hata ? null : <div className="ccd-inline-note">Yükleniyor…</div>
      ) : satirlar.length === 0 ? (
        <div className="ccd-empty">
          {kapsam === 'bugun' ? 'Bugün yapılacak bir şey yok. 👌' : 'Hatırlatma yok.'}
        </div>
      ) : (
        <div className="ccd-stack-sm ccd-bugun-liste">
          {satirlar.map((h) => (
            <div key={h.id} className={`ccd-card ccd-row-between ccd-bugun-kart${h.gecikti ? ' ccd-bugun-gec' : ''}`} style={{ flexWrap: 'wrap', gap: 10 }}>
              <div className="ccd-bugun-metin">
                <div style={{ fontWeight: 600 }}>
                  {h.gecikti && <span className="ccd-kpi-down">● </span>}{h.title}
                </div>
                <div className="ccd-meta">
                  {h.cari && <Link to={`/crm/${h.cari.id}`}>{h.cari.name}</Link>}
                  {h.cari && ' · '}
                  <span className={h.gecikti ? 'ccd-kpi-down' : ''}>{formatTarih(h.dueAt)}</span>
                  {h.sahip && ` · ${h.sahip}`}
                </div>
              </div>
              <div className="ccd-row ccd-bugun-eylem" style={{ flexWrap: 'wrap' }}>
                {/* Telefonda tek dokunuşla arama (masaüstünde gizli: orada telefon bağlantısı işe yaramaz). */}
                {h.cari?.phone && <a className="ccd-btn ccd-btn-sm ccd-yalniz-dar" href={`tel:${h.cari.phone.replace(/[^+\d]/g, '')}`}>Ara</a>}
                {waLink(h.cari?.phone) && (
                  <a className="ccd-btn ccd-btn-sm" href={waLink(h.cari?.phone)!}
                     target="_blank" rel="noreferrer">WhatsApp</a>
                )}
                {h.status === 'ACIK' && can('quote.write') && (
                  <>
                    <button className="ccd-btn ccd-btn-primary ccd-btn-sm"
                            onClick={() => durum(h.id, 'TAMAM')}>Tamamlandı</button>
                    <button className="ccd-btn ccd-btn-ghost ccd-btn-sm"
                            onClick={() => durum(h.id, 'IPTAL')}>İptal</button>
                  </>
                )}
                {h.status !== 'ACIK' && <span className="ccd-badge">{h.status}</span>}
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
